import { Fragment } from 'react'
import { parseTextLinks } from '@/utils/linkifyText'

interface TextWithLinksProps {
  text: string
}

// Renders markdown-style links written in a plain-text field as real anchors.
// Nodes rather than an HTML string: these strings are admin-typed plain text,
// so nothing in them should ever be interpreted as markup.
const TextWithLinks = ({ text }: TextWithLinksProps) => (
  <>
    {parseTextLinks(text).map((segment, index) => (
      <Fragment key={index}>
        {segment.href ? (
          <a
            href={segment.href}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
            // A consent link sits inside the checkbox's <label>: without this
            // the click toggles the box instead of opening the policy.
            onClick={(event) => event.stopPropagation()}
          >
            {segment.text}
          </a>
        ) : (
          segment.text
        )}
      </Fragment>
    ))}
  </>
)

export default TextWithLinks
